<!-- eslint-disable-next-line @shopliftr/angular/no-mat-form-field-subscript-sizing -- The password control has special multi-line error display characteristics this is required --> 
<mat-form-field subscriptSizing="dynamic" id="mat-password-field">
    <mat-label>New Password</mat-label>
    <input mgdClearInput matInput name="password" [formControl]="passwordFormControl" type="password" mgdEnhancedControl #passwordControl="mgdEnhancedControl" />
    <!-- eslint-disable-next-line @shopliftr/angular/require-mat-form-field-error-message -- The password control has special multi-line error display characteristics -->
    <mat-error class="mat-password-errors">
        <ul>
            <li [class.no-error]="passwordFormControl.errors?.passwordLength">
                Must be at least 8 characters
            </li>
            <li [class.no-error]="passwordFormControl.errors?.passwordDigit">
                Must have at least 1 numeric digit
            </li>
            <li [class.no-error]="passwordFormControl.errors?.passwordSymbol">
                Must be at least 1 symbol (~^+_\-=#.&#64;$!%*?&)
            </li>
            <li [class.no-error]="passwordFormControl.errors?.passwordLowerCaseLetter">
                Must have at least 1 lower case letter
            </li>
            <li [class.no-error]="passwordFormControl.errors?.passwordUpperCaseLetter">
                Must have at least 1 upper case letter
            </li>
        </ul>
    </mat-error>
    <mgd-clear-button matSuffix [formField]="passwordControl" />
</mat-form-field>
@if (passwordFormControl.valid) {
<mat-form-field id="mat-confirm-password-field">
    <mat-label>Confirm New Password</mat-label>
    <input mgdClearInput matInput name="confirmPassword" [formControl]="confirmPasswordFormControl"
      type="password" mgdEnhancedControl #confirmPasswordControl="mgdEnhancedControl" />
    <mat-error>
        <mgd-error-message [formField]="confirmPasswordControl"></mgd-error-message>
    </mat-error>
    <mgd-clear-button matSuffix [formField]="confirmPasswordControl" />
</mat-form-field>
}
